(function () {
  function onReady(img) {
    if (!img) return;
    if (img.complete) {
      img.classList.add("is-loaded");
      return;
    }
    img.addEventListener(
      "load",
      function () {
        img.classList.add("is-loaded");
      },
      { once: true }
    );
    img.addEventListener(
      "error",
      function () {
        img.classList.add("is-loaded");
      },
      { once: true }
    );
  }

  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll(
        ".product__photos img, .product__thumbs img, img.image-element--skeleton-loading"
      )
      .forEach(onReady);
  });
})();
